module.exports = __webpack_public_path__ + "img/informacion.47fd2181.svg";